export enum ACER_GROUP_KEY {
	ORIENTATION = 'orientation',
	MEMORY_REMEMBERING = 'memoryRemembering',
	ATTENTION_AND_COUNTING = 'attentionAndCounting',
	MEMORY_RECALLING = 'memoryRecalling',
	MEMORY_ANTEROGRADE = 'memoryAnterograde',
	MEMORY_RETROGRADE = 'memoryRetrograde',
	WORD_PRODUCTION = 'wordProduction',
	LANGUAGE_UNDERSTANDING = 'languageUnderstanding',
	LANGUAGE_PRODUCTION = 'languageProduction',
	LANGUAGE_REPETITION = 'languageRepetition',
	LANGUAGE_NAMING = 'languageNaming',
	LANGUAGE_READING = 'languageReading',
	VISUAL_SPATIAL_ABILITIES = 'visualSpatialAbilities',
	PERCEPTUAL_ABILITIES = 'perceptualAbilities',
	MEMORY_RE_RECOGNITION = 'memoryReRecognition',
}

export const ACER_GROUP_KEY_MAP: Record<ACER_GROUP_KEY, string> = {
	[ACER_GROUP_KEY.ORIENTATION]: 'Orientace',
	[ACER_GROUP_KEY.MEMORY_REMEMBERING]: 'Paměť - zapamatování',
	[ACER_GROUP_KEY.ATTENTION_AND_COUNTING]: 'Pozornost a počítání',
	[ACER_GROUP_KEY.MEMORY_RECALLING]: 'Paměť - vybavení',
	[ACER_GROUP_KEY.MEMORY_ANTEROGRADE]: 'Paměť - anterográdní',
	[ACER_GROUP_KEY.MEMORY_RETROGRADE]: 'Paměť - retrográdní',
	[ACER_GROUP_KEY.WORD_PRODUCTION]: 'Slovní produkce',
	[ACER_GROUP_KEY.LANGUAGE_UNDERSTANDING]: 'Jazyk - porozumění',
	[ACER_GROUP_KEY.LANGUAGE_PRODUCTION]: 'Jazyk - produkce',
	[ACER_GROUP_KEY.LANGUAGE_REPETITION]: 'Jazyk - opakování',
	[ACER_GROUP_KEY.LANGUAGE_NAMING]: 'Jazyk - pojmenování',
	[ACER_GROUP_KEY.LANGUAGE_READING]: 'Jazyk - čtení',
	[ACER_GROUP_KEY.VISUAL_SPATIAL_ABILITIES]: 'Zrakově prostorové schopnosti',
	[ACER_GROUP_KEY.PERCEPTUAL_ABILITIES]: 'Percepční schopnosti',
	[ACER_GROUP_KEY.MEMORY_RE_RECOGNITION]: 'Paměť - znovurozpoznání',
};

export const ACER_MAP: Record<
	string,
	{ title: string; maxScore: number | null; groupKey: ACER_GROUP_KEY | null }
> = {
	'152607e0-e1ab-42eb-9b95-dcd6f313619e': {
		title: 'Označení pacienta',
		maxScore: null,
		groupKey: null,
	},
	'2d91bd26-c2af-4f75-a745-a63e26c50cd4': {
		title: 'Který dnes den v týdnu ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'579eaef1-1b5b-4d9a-aaf3-2b77724afb5c': {
		title: 'Kolikáteho je dnes ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'40ef2b16-69c6-4f66-bff3-dd9a4b57bde4': {
		title: 'Který je měsíc ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'9c26c1fb-da27-4cad-a974-7e2a224dfd82': {
		title: 'Který je rok ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'0784a4f4-19c3-47f6-8040-4793c3c0ca15': {
		title: 'Které je roční období ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'5bf47013-c01e-458c-b1f2-245fbe0655aa': {
		title: 'Ve kterém státě se nacházíme ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'ddf4de5c-a369-4b6e-80f0-dff1f6fa1df8': {
		title: 'Ve kterém jsme městě ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'9fa33a84-79ff-4e30-916b-c933b11a1062': {
		title: 'Ve kterém jsme kraji nebo oblasti ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'165a2e50-637f-4a2e-ac99-ba937c0671ce': {
		title: 'Jak se jmenuje tato nemocnice / budova ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'4243639d-d44f-4f9c-9fbd-3ac7e37ff3b5': {
		title: 'Na kterém poschodí se nacházíme ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.ORIENTATION,
	},
	'56085389-55d4-43fa-87fa-797b31f77f39': {
		title: 'Řeknu Vám 3 slova, opakujte po mě.',
		maxScore: 3,
		groupKey: ACER_GROUP_KEY.MEMORY_REMEMBERING,
	},
	'e6f88124-d3bf-491a-ac0f-1e1583af3cf0': {
		title: 'Odčítání od 100.',
		maxScore: 5,
		groupKey: ACER_GROUP_KEY.ATTENTION_AND_COUNTING,
	},
	'd56b9ea1-d412-438b-922b-294cdc07a882': {
		title: 'Vybavení 3 slov.',
		maxScore: 3,
		groupKey: ACER_GROUP_KEY.MEMORY_RECALLING,
	},
	'504b89a0-c7fc-47ff-93e7-8596049cda17': {
		title: 'Adresa poprvé.',
		maxScore: null,
		groupKey: ACER_GROUP_KEY.MEMORY_ANTEROGRADE,
	},
	'cfff1d0f-bf14-439f-9282-f1a97f6e563b': {
		title: 'Adresa podruhé.',
		maxScore: null,
		groupKey: ACER_GROUP_KEY.MEMORY_ANTEROGRADE,
	},
	'91bda5f7-ddc9-456a-b9b0-9f292348211e': {
		title: 'Adresa potřetí.',
		maxScore: 7,
		groupKey: ACER_GROUP_KEY.MEMORY_ANTEROGRADE,
	},
	'56c23b8d-3870-4f33-8cde-c8fb5ddea259': {
		title: 'Kdo je současným předsedou vlády (premiérem) ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RETROGRADE,
	},
	'c938ffbd-fe80-46dc-b402-3303884cc768': {
		title:
			'Kdo byl prvním prezidentem naší republiky po revoluci v roce 1989 ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RETROGRADE,
	},
	'e571ff3a-c33e-4a70-858c-27c4f4bd7777': {
		title: 'Kdo je současným přezidentem Spojených států amerických ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RETROGRADE,
	},
	'fc24df6d-2722-4a78-8639-35c80523db32': {
		title:
			'Který prezident Spojených států amerických byl zavražděň v roce 1963 ?',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RETROGRADE,
	},
	'71d7a296-54b9-49b4-a553-223a3030a090': {
		title: 'Vyjmenujte co nejvíce slov začínající na písmeno P.',
		maxScore: 7,
		groupKey: ACER_GROUP_KEY.WORD_PRODUCTION,
	},
	'68aeb2d0-7821-4c13-a16f-57dc5e1295a8': {
		title: 'Vyjmenujte co nejvíce zvířat.',
		maxScore: 7,
		groupKey: ACER_GROUP_KEY.WORD_PRODUCTION,
	},
	'9cda6b64-f50f-426a-bcff-588c63e6833b': {
		title: 'Položení prstu na bílý kruh.',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_UNDERSTANDING,
	},
	'3706d218-03ed-46c9-95ba-bf4035df1c63': {
		title: 'Položení prstu na tvary.',
		maxScore: 3,
		groupKey: ACER_GROUP_KEY.LANGUAGE_UNDERSTANDING,
	},
	'102d8570-fceb-45b0-9b65-3a690e80e29a': {
		title: 'Řekněte jakoukoliv jednoduchou větu.',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_PRODUCTION,
	},
	'5d061464-4ec4-4fd6-9a96-72dd8f71cb85': {
		title: 'Opakování slov - Chobotnice',
		maxScore: null,
		groupKey: ACER_GROUP_KEY.LANGUAGE_REPETITION,
	},
	'1a3abe83-c011-429c-a1e0-52e0bbbf9d08': {
		title: 'Opakování slov - Výstřednost',
		maxScore: null,
		groupKey: ACER_GROUP_KEY.LANGUAGE_REPETITION,
	},
	'c5067bf5-4cec-4ef5-8cf0-7b0751933fa1': {
		title: 'Opakování slov - Nesrozumitelný',
		maxScore: null,
		groupKey: ACER_GROUP_KEY.LANGUAGE_REPETITION,
	},
	'e9924f3a-9bcb-4861-861c-6c394f08ef6b': {
		title: 'Opakování slov - Statistik',
		maxScore: 2,
		groupKey: ACER_GROUP_KEY.LANGUAGE_REPETITION,
	},
	'857ee943-82b1-46cc-b4b1-5cc1e6267786': {
		title: 'Opakování věty - Prostě tak a ne jinak.',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_REPETITION,
	},
	'376f1788-d50f-4e40-912e-6822f5dc9a96': {
		title: 'Opakování věty - Nahoře vzadu a dole',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_REPETITION,
	},
	'bd071426-83d4-438a-8c63-e94f2794b69e': {
		title: 'Pojmenování obrázku - Tužka',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'de840854-52bf-4b86-a9fd-d3d0a2632c87': {
		title: 'Pojmenování obrázku - Hodinky',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'78ff829d-1c0a-4cfc-bdc4-6cc1b35a700f': {
		title: 'Pojmenování obrázku - Klokan',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'e3054632-2b9a-4f59-b575-562f26d9fc3e': {
		title: 'Pojmenování obrázku - Tučňák',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'3337d60f-515e-474a-adb9-2d5ebefdd43d': {
		title: 'Pojmenování obrázku - Kotva',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'6a683418-9338-4bff-80b1-db917494c471': {
		title: 'Pojmenování obrázku - Velbloud',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'76187938-00f3-4a1c-a539-9561c3f1a50f': {
		title: 'Pojmenování obrázku - Harfa',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'f90e21c1-166a-4510-bf72-cef434665691': {
		title: 'Pojmenování obrázku - Nosorožec',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'7f6853c2-1cf4-4b30-8fbd-7aea0791c9e6': {
		title: 'Pojmenování obrázku - Sud',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'b303d8d8-36fd-4b38-8a48-ca0b58c8ab40': {
		title: 'Pojmenování obrázku - Koruna',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'1f309c81-9100-4bfa-96d1-c9b19b7e7f4c': {
		title: 'Pojmenování obrázku - Krokodýl',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'2973ae63-0d54-4762-9517-262ca2d41505': {
		title: 'Pojmenování obrázku - Harmonika',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_NAMING,
	},
	'a74760eb-a3e2-424a-977b-7e51babcb772': {
		title: 'Pojmenování obrázku - Obrázek související s královstvím',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_UNDERSTANDING,
	},
	'01c33af7-ce35-4b1c-b69d-38324890292f': {
		title: 'Pojmenování obrázku - Obrázek na kterém je vačnatec',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_UNDERSTANDING,
	},
	'7f2e1d9c-62fd-44fd-94e2-005b3a24c70d': {
		title: 'Pojmenování obrázku - Obrázek související s antarktidou',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_UNDERSTANDING,
	},
	'72debb1f-4a4c-415f-b154-3c40233197a1': {
		title: 'Pojmenování obrázku - Obrázek související s námořnictvím',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_UNDERSTANDING,
	},
	'a380bd6b-a257-4145-8eef-b1346c739e70': {
		title: 'Přečtěte následující slova',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.LANGUAGE_READING,
	},
	'1ecac0aa-d708-4b3e-bd3a-07f2b1ba32b7': {
		title: 'Nakreslete překrývající se petiúhelníky',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.VISUAL_SPATIAL_ABILITIES,
	},
	'c23570f6-56ab-452a-b4d5-227d4354478d': {
		title: 'Nakreslete krychly',
		maxScore: 2,
		groupKey: ACER_GROUP_KEY.VISUAL_SPATIAL_ABILITIES,
	},
	'd9169691-be6b-4c59-a181-cb042b666b2a': {
		title: 'Nakreslete hodiny',
		maxScore: 5,
		groupKey: ACER_GROUP_KEY.VISUAL_SPATIAL_ABILITIES,
	},
	'0bf2adad-b798-4ee2-8213-70ca72540190': {
		title: 'Počání teček - 8 teček',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'2eb36830-2dfa-4524-8d2a-5930c478eccd': {
		title: 'Počání teček - 10 teček',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'8ac38823-96e8-42bb-950d-cfb71ef7b00e': {
		title: 'Počání teček - 7 teček',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'fbbccd1a-0b17-430c-9b8b-d3aa9f809a26': {
		title: 'Počání teček - 9 teček',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'c8f2148e-0a15-42e7-9d7b-977cb10d9790': {
		title: 'Čtení písmen - K',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'c0f84925-399c-41eb-a7f2-b5f9835e818d': {
		title: 'Čtení písmen - M',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'34c17d52-a11f-4f1a-8069-01015d125bf7': {
		title: 'Čtení písmen - A',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'a682c2de-406a-49c7-b5e6-fd8a0703de37': {
		title: 'Čtení písmen - T',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.PERCEPTUAL_ABILITIES,
	},
	'78aeceba-af60-411b-bf21-d76d5d7f71ee': {
		title: 'Vybavení adresy',
		maxScore: 7,
		groupKey: ACER_GROUP_KEY.MEMORY_RECALLING,
	},
	'dc8e8aeb-6bef-4dd4-981e-4091b5f8d076': {
		title: 'Nápověda k adrese - Jméno',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RE_RECOGNITION,
	},
	'21434c72-f004-4315-bd30-2f3cfffb6fe0': {
		title: 'Nápověda k adrese - Ulice',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RE_RECOGNITION,
	},
	'24af35c0-71a6-4c76-add2-fedacf7f0fba': {
		title: 'Nápověda k adrese - Číslo domu',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RE_RECOGNITION,
	},
	'93d91b1e-95da-4096-a362-234ace03741a': {
		title: 'Nápověda k adrese - Čtvrť',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RE_RECOGNITION,
	},
	'05b52641-d89d-451c-aaa1-0dae931821d2': {
		title: 'Nápověda k adrese - Obec',
		maxScore: 1,
		groupKey: ACER_GROUP_KEY.MEMORY_RE_RECOGNITION,
	},
};
